module.exports = __webpack_public_path__ + "img/kh.6723397d.svg";